module.exports = __webpack_public_path__ + "static/media/icon-hb-money-bg-web.ff5ebafa.svg";